import React, { memo } from 'react'

  const Table = ({ columns, data }) => {

    const totalSetWidth = columns.reduce((total, col) => {
      return total + (col.width ? parseFloat(col.width) : 0);
    }, 0);
    
    const numColsWithoutWidth = columns.filter(col => !col.width).length;

    const remainingWidthPerCol = numColsWithoutWidth > 0 ? (100 - totalSetWidth) / numColsWithoutWidth : 0;

    const tableStyle = {
        color: '#fff',
        borderCollapse: 'collapse',
        width: '100%',
        margin: '20px 0',
    };

    const thTdStyle = (width) => ({
        padding: '3px',
        width: width ? width : `${remainingWidthPerCol}%`,
    });

    const headerRowStyle = {
        backgroundColor: '#FFC107',
    };

    return (
      <table style={tableStyle}>
        <thead style={headerRowStyle}>
          <tr>
              {columns.map((col) => (
                  <th key={col.key} style={thTdStyle(col.width)}>
                      {col.title}
                  </th>
              ))}
          </tr>
        </thead>
        <tbody>
          {data.map((row, rowIndex) => (
            <tr key={rowIndex}>
              {columns.map((col) => (
                <td key={`${col.key}-${rowIndex}`} style={thTdStyle(col.width)}>
                  {row[col.key]}
                </td>
              ))}
            </tr>
          ))}
        </tbody>
      </table>
    );
};


export default memo(Table)